import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('/api/v1/report/usage/daily', () => {
    return HttpResponse.json({});
  }),
];

export default handlers;
